import React from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  RedditIcon,
  RedditShareButton,
} from "react-share";

const iconStyles = {
  height: 40,
  width: 40,
};

const buttonStyles = {
    display: 'flex',
    alignItems: 'center',
    width: 150,
    fontWeight: 400
}

const labelStyles = {
    marginLeft: 20,
}

function Share({ title, url, hashtags }) {
  return (
    <div style={{
        display: 'flex',
        flexDirection: 'column'
    }}>
      <FacebookShareButton style={buttonStyles} quote={title} url={url} hashtag={"#" + hashtags[0]}>
        <FacebookIcon style={iconStyles} />
        <div style={labelStyles}>Facebook</div>
      </FacebookShareButton>
      <TwitterShareButton style={buttonStyles} title={title} url={url} hashtags={hashtags}>
        <TwitterIcon style={iconStyles} /> 
        <div style={labelStyles}>Twitter</div>
      </TwitterShareButton>
      <RedditShareButton style={buttonStyles} url={url} title={title}>
        <RedditIcon style={iconStyles} />
        <div style={labelStyles}>Reddit</div>
      </RedditShareButton>
    </div>
  );
}

export default Share;
